import React from "react";

const HEADING_STYLES = {
  2: "font-semibold text-2xl text-gray-900 dark:text-white mb-4",
  3: "font-medium text-xl text-gray-900 dark:text-white mt-8 mb-3",
  4: "font-semibold text-lg text-gray-900 dark:text-white mb-2",
};

export default function LegalSection({
  id,
  title,
  level = 2,
  children,
  className = "",
}) {
  const Heading = `h${level}`;
  const headingStyle = HEADING_STYLES[level] || HEADING_STYLES[2];

  return (
    <section id={id} tabIndex={-1} className={className}>
      {title && <Heading className={`font-display ${headingStyle}`}>{title}</Heading>}
      {children}
    </section>
  );
}
